import "./NxCertified.css";

import icon1 from "../../assets/image/1.svg";
import icon2 from "../../assets/image/2.svg";
import icon3 from "../../assets/image/3.svg";
import icon4 from "../../assets/image/4.svg";
import icon5 from "../../assets/image/5.svg";
import icon6 from "../../assets/image/6.svg";

const data = [
  {
    icon: icon1,
    title: "Service Professionals",
    desc: "900+ sales and technical professionals provide customized IT solutions to help meet complex business challenges.",
  },
  {
    icon: icon2,
    title: "Global Delivery Excellence",
    desc: "7 local warehouses guarantee that 90% of orders will be shipped on the same day.",
  },
  {
    icon: icon3,
    title: "Real-Time Support",
    desc: "NX provides whole process from pre-sales, in-sales to after-sales support.",
  },
  {
    icon: icon4,
    title: "Customizable R&D",
    desc: "NX Advanced R&D Center customizes software and hardware according to your requirements.",
  },
  {
    icon: icon5,
    title: "Comprehensive Test",
    desc: "8 top testing labs conduct comprehensive testing for your products and solutions.",
  },
  {
    icon: icon6,
    title: "Certified Quality",
    desc: "NX products have earned numerous international certifications such as ISO, CE, RoHS, etc.",
  },
];

export default function NxCertified() {
  return (
    <section className="nx-certified py-5">
      <div className="container">
        <div className="row mb-4">
          <div className="col text-center">
            <h2 className="fw-semibold" style={{color:"#fff"}}>NX Certified</h2>
          </div>
        </div>

        <div className="row g-4">
          {data.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="nx-card1 text-center">
                <div className="nx-icon">
                  <img src={item.icon} alt={item.title} />
                </div>
                <h6>
                  {item.title} <span></span>
                </h6>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
